
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12337',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12337",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.468",
  "data-fetching-client": "static-1.9687",
  "foundations-components": "static-1.7977",
  "foundations-components-legacy": "static-1.1002",
  "foundations-theming": "static-1.4440",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.82",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8033",
  "hub-http-shared-msw-handlers": "static-1.10014",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11492",
  "I18n": "static-7.1631",
  "jasmine-runner": "static-1.6483",
  "marketplace-storefront-base": "static-1.12398",
  "quartz": "static-1.7057",
  "react-dlb": "static-1.79",
  "react-rhumb": "static-1.16691",
  "reactive-variable-buffer-atom": "static-1.2878",
  "reporting-testing-lib": "static-1.9583",
  "settings-ui-lib": "static-1.12540",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7176",
  "ui-addon-i18n": "static-1.11168",
  "ui-addon-react-router-dom": "static-1.9562",
  "unified-auth": "static-1.516",
  "unified-auth-core-lib": "static-1.798",
  "usage-tracker": "static-1.7365",
  "usage-tracker-core": "static-1.7215",
  "customer-data-property-utils": "static-1.8110",
  "hub-http": "static-1.6241",
  "integrations-lib": "static-1.16217",
  "marketplace-ui-common": "static-1.19804",
  "property-management-iframe": "static-1.13228",
  "quartz-config": "static-1.835",
  "quartz-core": "static-1.6276",
  "quartz-routing": "static-1.487",
  "quick-fetch": "static-1.3931",
  "react": "static-7.186",
  "rpc-client-utils": "static-1.4672",
  "ts-schema": "static-1.4094",
  "ui-universal-auth": "static-1.9002",
  "UIComponents": "static-3.8438",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3413",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3334",
  "quartz-webpack": "static-1.3281",
  "bend-plugin-quartz-routing": "static-1.135",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4246",
  "floating-ui": "static-1.56",
  "foundations-assets": "static-1.4888",
  "foundations-theming-specialty": "static-1.2156",
  "framer-motion": "static-1.72",
  "hs-story-utils": "static-1.9444",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5359",
  "react-virtualized": "static-2.99",
  "StyleGuideUI": "static-3.487",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.2009",
  "ui-fonts": "static-1.754",
  "ui-images": "static-2.1160",
  "bend-plugin-foundations-theming": "static-1.2923",
  "foundations-theming-base": "static-1.3425",
  "stylex": "static-1.33",
  "HeadJS": "static-2.764",
  "hs-test-utils-bend-plugin": "static-1.3144",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4347",
  "ai-components-ui-library": "static-1.9035",
  "ai-rendering-library": "static-1.10247",
  "chirp-fetch": "static-1.1907",
  "connections-embed-lib": "static-1.1026",
  "copilot-toolkit": "static-1.11187",
  "feedback-loader": "static-1.29333",
  "laboratory-lib": "static-3.7175",
  "marketplace-embed": "static-1.22154",
  "marketplace-ui-details": "static-1.9700",
  "marketplace-ui-reviews": "static-1.19760",
  "marketplace-ui-tracking": "static-1.13975",
  "sanitize-text": "static-1.8162",
  "ui-addon-video-player": "static-1.8722",
  "usage-tracker-multi": "static-1.5779",
  "usage-tracker-session-replay": "static-1.5051",
  "wootric-nps": "static-1.6994",
  "quartz-head": "static-1.722",
  "web-vitals": "static-1.6",
  "apollo-link-hub-http": "static-2.4671",
  "immer": "static-1.33",
  "immerable": "static-1.4173",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2500",
  "reporting-data": "static-1.67650",
  "cssUtils": "static-1.798",
  "flux-actions": "static-1.341",
  "HubStyle": "static-2.11799",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10227",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10386",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7355",
  "icons": "static-2.650",
  "marketplace-ui-apps-core": "static-1.18337",
  "storybook-react": "static-1.33",
  "trellis-story-utils": "static-1.4535",
  "foundations-components-test-utils": "static-1.5460",
  "quartz-i18n": "static-1.732",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.303",
  "microsoft-drive-integration-lib": "static-1.431",
  "slack-ui-library": "static-1.10412",
  "fsm": "static-1.3750",
  "customer-data-objects": "static-1.7690",
  "property-translator": "static-1.5419",
  "hs-locale-management": "static-1.95",
  "frontend-preferences-client": "static-1.7947",
  "hs-promise-utils": "static-1.5610",
  "hubspot-apollo-client": "static-1.4899",
  "integrations-error-boundary-lib": "static-1.13632",
  "integrations-tracking-lib": "static-1.5621",
  "native-integrations-shared-strings": "static-1.7801",
  "reselect": "static-2.16",
  "sanitize": "static-1.4496",
  "superstore": "static-1.4781",
  "ui-shepherd-react": "static-3.10188",
  "ai-settings-ui-library": "static-1.7916",
  "hub-http-janus": "static-1.838",
  "hubspotter-http": "static-1.4666",
  "immutable-less": "static-1.4673",
  "marketplace-ui-client-types": "static-1.17211",
  "nav-meta": "static-1.29736",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10267",
  "ui-addon-upgrades": "static-9.18025",
  "inbound-db-properties-service-client": "static-1.3861",
  "property-management-common": "static-1.5517",
  "ui-addon-iframeable": "static-1.9078",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.732",
  "quartz-test": "static-1.732",
  "quartz-tracking": "static-1.436",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.82",
  "bender-build-tools": "static-1.3215",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21412",
  "ContentUtils": "static-1.68429",
  "customer-data-objects-ui-components": "static-1.13048",
  "sassPrefix": "static-1.156",
  "breeze-onboarding-components": "static-1.72",
  "avatar-components": "static-1.2518",
  "customer-data-filters-ui": "static-1.39871",
  "customer-data-reference-ui-components": "static-1.13185",
  "embedded-academy-lib": "static-1.14411",
  "ExportDialog": "static-6.10405",
  "highlight.js": "static-1.79",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41364",
  "reporting-snowflake": "static-1.56268",
  "reporting-ui-components": "static-2.64921",
  "reporting-visualizations": "static-1.59726",
  "ui-addon-teams": "static-1.21583",
  "magpie-lib": "static-1.5563",
  "navigation-components": "static-1.18099",
  "magpie-types": "static-1.5023",
  "simple-logging-lib": "static-1.3070",
  "ai-studio-lib": "static-1.11678",
  "app-governance-lib": "static-1.1605",
  "developer-experience-shared-components": "static-1.10529",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8018",
  "ui-product-approvals": "static-1.28198",
  "ui-tool-access": "static-1.10167",
  "usage-based-billing-components-lib": "static-1.9002",
  "usage-tracker-anonymous": "static-1.5782",
  "usage-tracker-public": "static-1.7176",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3601",
  "persist-promise": "static-1.3718",
  "reference-resolvers": "static-1.8190",
  "ui-extensibility-client-types": "static-1.3944",
  "hubspot-apollo-cache": "static-1.358",
  "universal-page-editor-lib": "static-1.3033",
  "final-form": "static-1.70",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2841",
  "merchandise-lib": "static-1.264",
  "atom": "static-1.5092",
  "purchase-motions-components": "static-1.5946",
  "salesImages": "static-1.525",
  "batch-promise": "static-1.1561",
  "crm-component-utils": "static-1.39135",
  "crm-properties-common-lib": "static-1.5904",
  "customer-data-properties": "static-1.51632",
  "framework-data-schema-resolvers": "static-1.6904",
  "property-value-citations": "static-1.2246",
  "reference-resolvers-lite": "static-1.8114",
  "ui-business-units-lib": "static-1.9074",
  "navigation-messaging": "static-1.7426",
  "hubspotter-http-shared-msw-handlers": "static-1.10012",
  "cms-field-types": "static-1.4832",
  "content-icons-ui": "static-1.2233",
  "customer-data-ui-utilities": "static-1.9846",
  "events-data-lib": "static-1.242",
  "conversations-skeleton-state": "static-1.7267",
  "crm-message-bus": "static-1.43040",
  "customer-data-filters-ui-msw-helpers": "static-1.22306",
  "FormUrlGenerator": "static-2.4738",
  "framework-builder-read-service-client": "static-1.4020",
  "framework-data-schema-quick-fetch": "static-1.6809",
  "multi-account-reference-resolvers": "static-1.999",
  "onboarding-tours": "static-1.16651",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13745",
  "academy-common-lib": "static-1.13871",
  "content-assistance-lib": "static-1.7782",
  "dashboard-lib": "static-1.81616",
  "file-manager-components": "static-1.23680",
  "getting-started-shared-tasks": "static-1.18517",
  "hubspot-prosemirror": "static-1.18289",
  "hubspot-prosemirror-plugins": "static-1.18281",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19868",
  "share-with-third-party-component-lib": "static-1.8721",
  "ui-addon-draggable": "static-3.4783",
  "ui-asset-management-lib": "static-1.11063",
  "user-context": "static-1.5125",
  "growth-payments-core": "static-1.25441",
  "reporting-plugins": "static-1.10358",
  "reporting-reports": "static-1.67328",
  "idb-keyval": "static-1.44",
  "reactive-lib": "static-1.743",
  "nest": "static-1.247",
  "codemirror": "static-5.95",
  "react-codemirror": "static-1.10646",
  "framework-listing-lib": "static-2.28769",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30765",
  "apps-service-types": "static-1.3899",
  "oauth-service-types": "static-1.4269",
  "ui-product-approvals-common": "static-1.93",
  "onboarding-scopes": "static-1.6481",
  "onboarding-tours-client": "static-1.4865",
  "platform-infra-nav-components": "static-1.7685",
  "subscription-experience-data-types": "static-1.14963",
  "crm-record-cards-service-types": "static-1.3612",
  "location-customization-utils-lib": "static-1.9327",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5949",
  "signup-constants": "static-1.18879",
  "signup-ui-url-generator": "static-2.8072",
  "trials-service-types": "static-1.3923",
  "card-properties-lib": "static-1.44250",
  "commerce-subscription-lib": "static-1.37183",
  "crm-actions": "static-1.6346",
  "crm-cards-sdk": "static-1.43652",
  "customer-data-properties-shared-msw-handlers": "static-1.9341",
  "customer-data-tracking": "static-1.6909",
  "hs-resources": "static-1.173",
  "pulse": "static-1.596",
  "calling-global-api": "static-1.64587",
  "calling-internal-common": "static-1.31322",
  "calling-lifecycle-internal": "static-1.65969",
  "calling-lifecycle-messages": "static-1.58263",
  "commerce-products-lib": "static-1.9647",
  "conditional-properties-service-client": "static-1.3812",
  "crm-links": "static-1.6314",
  "external-options-client-types": "static-1.4174",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4238",
  "meetings-icalendar-utils-lib": "static-1.651",
  "multi-currency-client-types": "static-1.3706",
  "object-builder-ui-client": "static-1.48816",
  "pipeline-validation-client-types": "static-1.3980",
  "smart-property-lib": "static-1.7189",
  "tiered-pricing": "static-1.1263",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11010",
  "crm-pipelines-api-client-types": "static-1.4154",
  "fdsr-migration-layer": "static-1.23",
  "react-dnd-compat": "static-1.4634",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.939",
  "growth-data-modal": "static-1.5459",
  "growth-onboarding-confetti": "static-1.3086",
  "growth-onboarding-next-action-utils": "static-1.1981",
  "onboarding-tours-utils": "static-1.717",
  "ui-shepherd-tracker": "static-1.7569",
  "academy-service-client": "static-1.3701",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39179",
  "FileManagerLib": "static-1.39320",
  "video-embed": "static-1.35836",
  "ui-coaching-tips": "static-1.28621",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11344",
  "video-data-lib": "static-1.35002",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8492",
  "payment-link-components": "static-1.23601",
  "ui-addon-emoji-picker": "static-1.9908",
  "EmailSignatureEditor": "static-1.24417",
  "viral-links-lib": "static-1.7086",
  "data-token-picker": "static-1.16442",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.246",
  "timezone-utils": "static-2.5264",
  "seat-types-lib": "static-1.59",
  "getting-started-shared-tasks-store": "static-1.17635",
  "ui-addon-opt": "static-4.8385",
  "campaign-roi-lib": "static-1.9185",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7345",
  "customer-data-views-management": "static-1.25505",
  "framework-data-table": "static-2.11962",
  "marketing-platform-lib": "static-1.6877",
  "nudge-client-utils": "static-1.2628",
  "nudge-custom-ui-functions": "static-1.1055",
  "app-users-service-client": "static-1.5617",
  "app-users-service-types": "static-1.5025",
  "mini-checkout-client": "static-1.26855",
  "onboarding-utils": "static-1.5373",
  "permissions-shared-i18n-strings-fe": "static-1.2046",
  "ui-coaching-tips-shared-config": "static-1.28606",
  "edison-service-client-types": "static-1.408",
  "crm_data": "static-4.92033",
  "customer-data-sidebar": "static-2.46078",
  "enrichment-properties-lib": "static-1.16307",
  "ui-addon-draggable-compat": "static-2.4276",
  "commerce-billing-lib": "static-1.19144",
  "commerce-shared-components-lib": "static-1.18597",
  "commerce-tools-ui-lib": "static-1.10434",
  "crm-fe-perf": "static-1.22923",
  "bend-plugin-pulse": "static-1.99",
  "directed-graph": "static-1.955",
  "event-emitter": "static-1.967",
  "fast-json-patch": "static-1.63",
  "calling-error-reporting": "static-1.31329",
  "shared-worker-versioning": "static-1.11056",
  "calling-usage-tracker": "static-1.6561",
  "voice-sms-access-library": "static-1.1064",
  "commerce-permissions": "static-1.789",
  "products-iframe-lib": "static-1.7996",
  "products-ui-components-shared-msw-handlers": "static-1.10396",
  "data-agent-kit": "static-1.226",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10097",
  "policy-lib": "static-1.6797",
  "react-tinymce": "static-1.55303",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10160",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54429",
  "tinymce-plugins": "static-1.57543",
  "tinymce-themes": "static-1.56399",
  "onboarding-data-sync-lib": "static-1.1988",
  "growth-onboarding-next-action-components": "static-1.2009",
  "user-context-client": "static-1.4632",
  "audio-components": "static-1.5945",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36831",
  "urlinator": "static-1.4556",
  "video-components": "static-1.13347",
  "outpost": "static-1.4200",
  "growth-onboarding-feedback-components": "static-1.6600",
  "content-media-composition-data-lib": "static-1.12387",
  "content-media-compositions": "static-2.16394",
  "media-bridge-lib": "static-1.18961",
  "commerce-tours-lib": "static-1.6140",
  "growth-onboarding-reliability": "static-1.5102",
  "sales-checkout-service-client": "static-1.3661",
  "draft-convert": "static-2.73",
  "draft-extend": "static-3.75",
  "draft-js": "static-5.78",
  "draft-plugins": "static-2.21711",
  "sales-email-signature-service-client": "static-1.3863",
  "ts-utils-lib": "static-1.192",
  "breeze-engine-lib": "static-1.720",
  "crm-export-dialog": "static-1.6310",
  "crm-index-associations-lib": "static-1.6460",
  "crm-view-components": "static-1.331",
  "react-beautiful-dnd": "static-1.13",
  "tanstack-virtual": "static-1.30",
  "nudge-custom-function-registry": "static-1.2385",
  "nudge-renderer-utils": "static-1.2704",
  "whisper-core-api": "static-1.6683",
  "InboxConnectUtils": "static-4.14874",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5601",
  "settings-content-modals": "static-1.46146",
  "crm_universal": "static-1.22042",
  "customer-data-email": "static-1.18069",
  "card-payment-highlight-lib": "static-1.37239",
  "card-subscription-highlight-lib": "static-1.39606",
  "commerce-contract-lib": "static-1.12149",
  "invoices-highlight-card-lib": "static-1.54798",
  "orders-highlight-card-lib": "static-1.21530",
  "products-highlight-card-lib": "static-1.17930",
  "quotes-highlight-card-lib": "static-1.72125",
  "crm-source-interpretation-lib": "static-1.5363",
  "utility-belt": "static-1.2554",
  "payments-enrollment-embed-lib": "static-1.22962",
  "stripe-embedded-components": "static-1.7541",
  "customer-data-rte": "static-1.33055",
  "cv-backend-services": "static-1.1553",
  "growth-onboarding-empty-states": "static-1.5768",
  "payments-post-enroll-local-storage-lib": "static-1.5128",
  "qrcode-generator": "static-1.69",
  "quotes-client-types": "static-1.38215",
  "calling-orchestration-schema": "static-1.35841",
  "sales-views-client-types": "static-1.4279",
  "hub-http-contrib": "static-1.3062",
  "interframe": "static-3.4779",
  "tinymce-data": "static-1.40514",
  "ui-addon-sales-email": "static-1.5230",
  "layout-dnd-components": "static-1.12483",
  "layout-dnd-utils": "static-1.11458",
  "ui-brand-identity-lib": "static-1.15368",
  "NamespacedHubStyle": "static-2.9073",
  "meetings-connect-utils-lib": "static-1.7625",
  "social-insights-client-types": "static-1.22180",
  "js-cookie": "static-1.18",
  "ably": "static-2.2",
  "crm-index-visualization-core": "static-1.4163",
  "checkout-sdk": "static-3.23698",
  "checkout-service-types": "static-1.3836",
  "company-details-components": "static-1.6215",
  "payment-method-components": "static-1.6924",
  "pricing-pages-ui-components": "static-1.14111",
  "quote-checkout-service-types": "static-1.3487",
  "upgrade-catalog-service-types": "static-1.3540",
  "access-control-lib": "static-1.10455",
  "EmailComponents": "static-1.54810",
  "EmailData": "static-1.53487",
  "redux-less": "static-2.9503",
  "sequences-lib": "static-1.8076",
  "ui-gdpr-components": "static-1.10370",
  "products-ui-components": "static-1.40165",
  "accounting-integrations-ui-components": "static-1.7097",
  "invoices-ui-lib": "static-1.54814",
  "commerce-products-api": "static-1.2326",
  "invoices-iframe-lib": "static-1.56872",
  "quotes-modal-lib": "static-1.102803",
  "quotes-ui-lib": "static-1.80846",
  "stripe-connect-js": "static-1.69",
  "draft-content-plugins": "static-1.28327",
  "ContentData": "static-1.68504",
  "layout-data-lib": "static-1.9783",
  "hub-http-rxjs": "static-1.804",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3959",
  "billing-payments-client-types": "static-1.4009",
  "react-performance-metrics-lib": "static-1.575",
  "account-and-billing-fintech-outages": "static-3.18617",
  "pricing-pages-api": "static-1.13976",
  "ContentComponents": "static-2.71385",
  "marketing-contacts-lib": "static-1.10115",
  "marketing-email-service-types": "static-1.1920",
  "messaging-editing-lib": "static-1.46339",
  "messaging-usage-based-billing-components-lib": "static-1.1201",
  "automation-ui-source-apps": "static-1.18953",
  "automation-ui-types": "static-1.19871",
  "messaging-types-lib": "static-1.46076",
  "onboarding-settings-client": "static-1.4524",
  "sequences-client-types-lib": "static-1.7933",
  "commerce-tax-lib": "static-1.546",
  "price-books-api": "static-1.818",
  "price-books-components": "static-1.876",
  "property-description-translator": "static-1.3863",
  "ramp-editor": "static-1.197",
  "commerce-analytics-service-client": "static-1.3649",
  "totals-ui-components": "static-1.23661",
  "SalesContentIndexUI": "static-3.9280",
  "advanced-menus-core": "static-1.15159",
  "advanced-menus-lib": "static-1.12097",
  "ui-memberships-settings-lib": "static-1.34106",
  "segments-query-core": "static-1.1438",
  "demographics-service-types": "static-1.1672",
  "eligibility-engine-service-types": "static-1.3204",
  "automation-ui-ubb": "static-1.5787",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7358",
  "data-token-views": "static-1.16423",
  "forms-utils-lib": "static-1.12623",
  "payments-embed-points-lib": "static-1.13079",
  "simple-menus-core": "static-1.15158",
  "simple-menus-lib": "static-1.16675",
  "videoconference-integration-components": "static-1.6849",
  "marketing-contacts-client": "static-1.7536",
  "automation-applications-service-types": "static-1.3528",
  "automation-platform-service-types": "static-1.2593",
  "ContentEditorUI": "static-2.77181",
  "short-messages-app-service-client": "static-1.3988",
  "web-interactives-components": "static-1.13794",
  "web-interactives-data": "static-1.13795",
  "messaging-shared-utils-lib": "static-1.650",
  "messaging-user-info-utils-lib": "static-1.820",
  "email-portal-health-service-types": "static-1.998",
  "line-items-api": "static-1.726",
  "commerce-totals-service-types": "static-1.3834",
  "FireAlarmUi": "static-1.4527",
  "sales-templates-service-types-lib": "static-1.4185",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21807",
  "automation-ui-usage-tracking": "static-1.21270",
  "data-studio-ubb": "static-1.2789",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27082",
  "collaboration-sidebar": "static-1.57893",
  "content-management-data-lib": "static-1.5415",
  "copilot-plugins": "static-1.11160",
  "cta-picker": "static-1.36462",
  "customer-agent-discovery-components-lib": "static-1.3145",
  "editor-components": "static-1.13256",
  "editor-iframe-lib": "static-1.8430",
  "error-messaging-js": "static-1.5212",
  "FormsCommonComponents": "static-1.85913",
  "pictos": "static-7.184",
  "react-transition-group": "static-2.65",
  "redux-request-state": "static-1.10665",
  "SharedLegalStrings": "static-1.1767",
  "smart-content-core": "static-1.42504",
  "smart-content-lib": "static-1.43157",
  "social-composer-lib": "static-1.59246",
  "structured-content-lib": "static-1.25251",
  "theme-previewer-lib": "static-1.53306",
  "tinymce-copilot": "static-1.16497",
  "xray-recommendation-lib": "static-1.7935",
  "automation-ui-routing": "static-1.21228",
  "sql-reporting-client-types": "static-1.5653",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42245",
  "campaigns-utils-lib": "static-1.3201",
  "reporting-enablement": "static-1.23000",
  "chatspot-widget-iframe": "static-1.21403",
  "collaboration-sidebar-common": "static-1.2690",
  "forms-ai-lib": "static-1.4349",
  "codemirror-dlb": "static-1.58740",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6451",
  "report-customization-components": "static-1.13230",
  "data-quality-ui-library": "static-1.13090",
  "html-to-image": "static-1.54",
  "reporting-filters": "static-1.379",
  "reporting-insights-lib": "static-1.1812"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12337",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.468",
  "data-fetching-client": "/data-fetching-client/static-1.9687",
  "foundations-components": "/foundations-components/static-1.7977",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1002",
  "foundations-theming": "/foundations-theming/static-1.4440",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.82",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8033",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10014",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11492",
  "I18n": "/I18n/static-7.1631",
  "jasmine-runner": "/jasmine-runner/static-1.6483",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12398",
  "quartz": "/quartz/static-1.7057",
  "react-dlb": "/react-dlb/static-1.79",
  "react-rhumb": "/react-rhumb/static-1.16691",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2878",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9583",
  "settings-ui-lib": "/settings-ui-lib/static-1.12540",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7176",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11168",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9562",
  "unified-auth": "/unified-auth/static-1.516",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.798",
  "usage-tracker": "/usage-tracker/static-1.7365",
  "usage-tracker-core": "/usage-tracker-core/static-1.7215",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8110",
  "hub-http": "/hub-http/static-1.6241",
  "integrations-lib": "/integrations-lib/static-1.16217",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19804",
  "property-management-iframe": "/property-management-iframe/static-1.13228",
  "quartz-config": "/quartz-config/static-1.835",
  "quartz-core": "/quartz-core/static-1.6276",
  "quartz-routing": "/quartz-routing/static-1.487",
  "quick-fetch": "/quick-fetch/static-1.3931",
  "react": "/react/static-7.186",
  "rpc-client-utils": "/rpc-client-utils/static-1.4672",
  "ts-schema": "/ts-schema/static-1.4094",
  "ui-universal-auth": "/ui-universal-auth/static-1.9002",
  "UIComponents": "/UIComponents/static-3.8438",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3413",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3334",
  "quartz-webpack": "/quartz-webpack/static-1.3281",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.135",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4246",
  "floating-ui": "/floating-ui/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4888",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2156",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-story-utils": "/hs-story-utils/static-1.9444",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5359",
  "react-virtualized": "/react-virtualized/static-2.99",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.2009",
  "ui-fonts": "/ui-fonts/static-1.754",
  "ui-images": "/ui-images/static-2.1160",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2923",
  "foundations-theming-base": "/foundations-theming-base/static-1.3425",
  "stylex": "/stylex/static-1.33",
  "HeadJS": "/HeadJS/static-2.764",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3144",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4347",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9035",
  "ai-rendering-library": "/ai-rendering-library/static-1.10247",
  "chirp-fetch": "/chirp-fetch/static-1.1907",
  "connections-embed-lib": "/connections-embed-lib/static-1.1026",
  "copilot-toolkit": "/copilot-toolkit/static-1.11187",
  "feedback-loader": "/feedback-loader/static-1.29333",
  "laboratory-lib": "/laboratory-lib/static-3.7175",
  "marketplace-embed": "/marketplace-embed/static-1.22154",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9700",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19760",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13975",
  "sanitize-text": "/sanitize-text/static-1.8162",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8722",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5779",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5051",
  "wootric-nps": "/wootric-nps/static-1.6994",
  "quartz-head": "/quartz-head/static-1.722",
  "web-vitals": "/web-vitals/static-1.6",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4671",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4173",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2500",
  "reporting-data": "/reporting-data/static-1.67650",
  "cssUtils": "/cssUtils/static-1.798",
  "flux-actions": "/flux-actions/static-1.341",
  "HubStyle": "/HubStyle/static-2.11799",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10227",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10386",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7355",
  "icons": "/icons/static-2.650",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18337",
  "storybook-react": "/storybook-react/static-1.33",
  "trellis-story-utils": "/trellis-story-utils/static-1.4535",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5460",
  "quartz-i18n": "/quartz-i18n/static-1.732",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.303",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.431",
  "slack-ui-library": "/slack-ui-library/static-1.10412",
  "fsm": "/fsm/static-1.3750",
  "customer-data-objects": "/customer-data-objects/static-1.7690",
  "property-translator": "/property-translator/static-1.5419",
  "hs-locale-management": "/hs-locale-management/static-1.95",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7947",
  "hs-promise-utils": "/hs-promise-utils/static-1.5610",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4899",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13632",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5621",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7801",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4496",
  "superstore": "/superstore/static-1.4781",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10188",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7916",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "hubspotter-http": "/hubspotter-http/static-1.4666",
  "immutable-less": "/immutable-less/static-1.4673",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17211",
  "nav-meta": "/nav-meta/static-1.29736",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10267",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18025",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3861",
  "property-management-common": "/property-management-common/static-1.5517",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9078",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.732",
  "quartz-test": "/quartz-test/static-1.732",
  "quartz-tracking": "/quartz-tracking/static-1.436",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.82",
  "bender-build-tools": "/bender-build-tools/static-1.3215",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21412",
  "ContentUtils": "/ContentUtils/static-1.68429",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13048",
  "sassPrefix": "/sassPrefix/static-1.156",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.72",
  "avatar-components": "/avatar-components/static-1.2518",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39871",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13185",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14411",
  "ExportDialog": "/ExportDialog/static-6.10405",
  "highlight.js": "/highlight.js/static-1.79",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41364",
  "reporting-snowflake": "/reporting-snowflake/static-1.56268",
  "reporting-ui-components": "/reporting-ui-components/static-2.64921",
  "reporting-visualizations": "/reporting-visualizations/static-1.59726",
  "ui-addon-teams": "/ui-addon-teams/static-1.21583",
  "magpie-lib": "/magpie-lib/static-1.5563",
  "navigation-components": "/navigation-components/static-1.18099",
  "magpie-types": "/magpie-types/static-1.5023",
  "simple-logging-lib": "/simple-logging-lib/static-1.3070",
  "ai-studio-lib": "/ai-studio-lib/static-1.11678",
  "app-governance-lib": "/app-governance-lib/static-1.1605",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10529",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8018",
  "ui-product-approvals": "/ui-product-approvals/static-1.28198",
  "ui-tool-access": "/ui-tool-access/static-1.10167",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9002",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5782",
  "usage-tracker-public": "/usage-tracker-public/static-1.7176",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3601",
  "persist-promise": "/persist-promise/static-1.3718",
  "reference-resolvers": "/reference-resolvers/static-1.8190",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3944",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.358",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3033",
  "final-form": "/final-form/static-1.70",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2841",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "atom": "/atom/static-1.5092",
  "purchase-motions-components": "/purchase-motions-components/static-1.5946",
  "salesImages": "/salesImages/static-1.525",
  "batch-promise": "/batch-promise/static-1.1561",
  "crm-component-utils": "/crm-component-utils/static-1.39135",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5904",
  "customer-data-properties": "/customer-data-properties/static-1.51632",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6904",
  "property-value-citations": "/property-value-citations/static-1.2246",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8114",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9074",
  "navigation-messaging": "/navigation-messaging/static-1.7426",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10012",
  "cms-field-types": "/cms-field-types/static-1.4832",
  "content-icons-ui": "/content-icons-ui/static-1.2233",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9846",
  "events-data-lib": "/events-data-lib/static-1.242",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7267",
  "crm-message-bus": "/crm-message-bus/static-1.43040",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22306",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4738",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4020",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6809",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.999",
  "onboarding-tours": "/onboarding-tours/static-1.16651",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13745",
  "academy-common-lib": "/academy-common-lib/static-1.13871",
  "content-assistance-lib": "/content-assistance-lib/static-1.7782",
  "dashboard-lib": "/dashboard-lib/static-1.81616",
  "file-manager-components": "/file-manager-components/static-1.23680",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18517",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18289",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18281",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19868",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8721",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4783",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11063",
  "user-context": "/user-context/static-1.5125",
  "growth-payments-core": "/growth-payments-core/static-1.25441",
  "reporting-plugins": "/reporting-plugins/static-1.10358",
  "reporting-reports": "/reporting-reports/static-1.67328",
  "idb-keyval": "/idb-keyval/static-1.44",
  "reactive-lib": "/reactive-lib/static-1.743",
  "nest": "/nest/static-1.247",
  "codemirror": "/codemirror/static-5.95",
  "react-codemirror": "/react-codemirror/static-1.10646",
  "framework-listing-lib": "/framework-listing-lib/static-2.28769",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30765",
  "apps-service-types": "/apps-service-types/static-1.3899",
  "oauth-service-types": "/oauth-service-types/static-1.4269",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.93",
  "onboarding-scopes": "/onboarding-scopes/static-1.6481",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4865",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7685",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14963",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3612",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9327",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5949",
  "signup-constants": "/signup-constants/static-1.18879",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8072",
  "trials-service-types": "/trials-service-types/static-1.3923",
  "card-properties-lib": "/card-properties-lib/static-1.44250",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37183",
  "crm-actions": "/crm-actions/static-1.6346",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43652",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9341",
  "customer-data-tracking": "/customer-data-tracking/static-1.6909",
  "hs-resources": "/hs-resources/static-1.173",
  "pulse": "/pulse/static-1.596",
  "calling-global-api": "/calling-global-api/static-1.64587",
  "calling-internal-common": "/calling-internal-common/static-1.31322",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65969",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58263",
  "commerce-products-lib": "/commerce-products-lib/static-1.9647",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3812",
  "crm-links": "/crm-links/static-1.6314",
  "external-options-client-types": "/external-options-client-types/static-1.4174",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4238",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.651",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3706",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48816",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3980",
  "smart-property-lib": "/smart-property-lib/static-1.7189",
  "tiered-pricing": "/tiered-pricing/static-1.1263",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11010",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4154",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.23",
  "react-dnd-compat": "/react-dnd-compat/static-1.4634",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.939",
  "growth-data-modal": "/growth-data-modal/static-1.5459",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3086",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1981",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.717",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7569",
  "academy-service-client": "/academy-service-client/static-1.3701",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39179",
  "FileManagerLib": "/FileManagerLib/static-1.39320",
  "video-embed": "/video-embed/static-1.35836",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28621",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11344",
  "video-data-lib": "/video-data-lib/static-1.35002",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8492",
  "payment-link-components": "/payment-link-components/static-1.23601",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9908",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24417",
  "viral-links-lib": "/viral-links-lib/static-1.7086",
  "data-token-picker": "/data-token-picker/static-1.16442",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.246",
  "timezone-utils": "/timezone-utils/static-2.5264",
  "seat-types-lib": "/seat-types-lib/static-1.59",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17635",
  "ui-addon-opt": "/ui-addon-opt/static-4.8385",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9185",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7345",
  "customer-data-views-management": "/customer-data-views-management/static-1.25505",
  "framework-data-table": "/framework-data-table/static-2.11962",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6877",
  "nudge-client-utils": "/nudge-client-utils/static-1.2628",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1055",
  "app-users-service-client": "/app-users-service-client/static-1.5617",
  "app-users-service-types": "/app-users-service-types/static-1.5025",
  "mini-checkout-client": "/mini-checkout-client/static-1.26855",
  "onboarding-utils": "/onboarding-utils/static-1.5373",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2046",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28606",
  "edison-service-client-types": "/edison-service-client-types/static-1.408",
  "crm_data": "/crm_data/static-4.92033",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46078",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16307",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4276",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19144",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18597",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10434",
  "crm-fe-perf": "/crm-fe-perf/static-1.22923",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.99",
  "directed-graph": "/directed-graph/static-1.955",
  "event-emitter": "/event-emitter/static-1.967",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "calling-error-reporting": "/calling-error-reporting/static-1.31329",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11056",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6561",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1064",
  "commerce-permissions": "/commerce-permissions/static-1.789",
  "products-iframe-lib": "/products-iframe-lib/static-1.7996",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10396",
  "data-agent-kit": "/data-agent-kit/static-1.226",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10097",
  "policy-lib": "/policy-lib/static-1.6797",
  "react-tinymce": "/react-tinymce/static-1.55303",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10160",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54429",
  "tinymce-plugins": "/tinymce-plugins/static-1.57543",
  "tinymce-themes": "/tinymce-themes/static-1.56399",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1988",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2009",
  "user-context-client": "/user-context-client/static-1.4632",
  "audio-components": "/audio-components/static-1.5945",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36831",
  "urlinator": "/urlinator/static-1.4556",
  "video-components": "/video-components/static-1.13347",
  "outpost": "/outpost/static-1.4200",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6600",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12387",
  "content-media-compositions": "/content-media-compositions/static-2.16394",
  "media-bridge-lib": "/media-bridge-lib/static-1.18961",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6140",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5102",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3661",
  "draft-convert": "/draft-convert/static-2.73",
  "draft-extend": "/draft-extend/static-3.75",
  "draft-js": "/draft-js/static-5.78",
  "draft-plugins": "/draft-plugins/static-2.21711",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3863",
  "ts-utils-lib": "/ts-utils-lib/static-1.192",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.720",
  "crm-export-dialog": "/crm-export-dialog/static-1.6310",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6460",
  "crm-view-components": "/crm-view-components/static-1.331",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.30",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2385",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2704",
  "whisper-core-api": "/whisper-core-api/static-1.6683",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14874",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5601",
  "settings-content-modals": "/settings-content-modals/static-1.46146",
  "crm_universal": "/crm_universal/static-1.22042",
  "customer-data-email": "/customer-data-email/static-1.18069",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37239",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39606",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12149",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54798",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21530",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17930",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72125",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5363",
  "utility-belt": "/utility-belt/static-1.2554",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22962",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7541",
  "customer-data-rte": "/customer-data-rte/static-1.33055",
  "cv-backend-services": "/cv-backend-services/static-1.1553",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5768",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5128",
  "qrcode-generator": "/qrcode-generator/static-1.69",
  "quotes-client-types": "/quotes-client-types/static-1.38215",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35841",
  "sales-views-client-types": "/sales-views-client-types/static-1.4279",
  "hub-http-contrib": "/hub-http-contrib/static-1.3062",
  "interframe": "/interframe/static-3.4779",
  "tinymce-data": "/tinymce-data/static-1.40514",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5230",
  "layout-dnd-components": "/layout-dnd-components/static-1.12483",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11458",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15368",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9073",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7625",
  "social-insights-client-types": "/social-insights-client-types/static-1.22180",
  "js-cookie": "/js-cookie/static-1.18",
  "ably": "/ably/static-2.2",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4163",
  "checkout-sdk": "/checkout-sdk/static-3.23698",
  "checkout-service-types": "/checkout-service-types/static-1.3836",
  "company-details-components": "/company-details-components/static-1.6215",
  "payment-method-components": "/payment-method-components/static-1.6924",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14111",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3487",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3540",
  "access-control-lib": "/access-control-lib/static-1.10455",
  "EmailComponents": "/EmailComponents/static-1.54810",
  "EmailData": "/EmailData/static-1.53487",
  "redux-less": "/redux-less/static-2.9503",
  "sequences-lib": "/sequences-lib/static-1.8076",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10370",
  "products-ui-components": "/products-ui-components/static-1.40165",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7097",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54814",
  "commerce-products-api": "/commerce-products-api/static-1.2326",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56872",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102803",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80846",
  "stripe-connect-js": "/stripe-connect-js/static-1.69",
  "draft-content-plugins": "/draft-content-plugins/static-1.28327",
  "ContentData": "/ContentData/static-1.68504",
  "layout-data-lib": "/layout-data-lib/static-1.9783",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.804",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3959",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4009",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.575",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18617",
  "pricing-pages-api": "/pricing-pages-api/static-1.13976",
  "ContentComponents": "/ContentComponents/static-2.71385",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10115",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1920",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46339",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1201",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18953",
  "automation-ui-types": "/automation-ui-types/static-1.19871",
  "messaging-types-lib": "/messaging-types-lib/static-1.46076",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4524",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7933",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.546",
  "price-books-api": "/price-books-api/static-1.818",
  "price-books-components": "/price-books-components/static-1.876",
  "property-description-translator": "/property-description-translator/static-1.3863",
  "ramp-editor": "/ramp-editor/static-1.197",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3649",
  "totals-ui-components": "/totals-ui-components/static-1.23661",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9280",
  "advanced-menus-core": "/advanced-menus-core/static-1.15159",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12097",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34106",
  "segments-query-core": "/segments-query-core/static-1.1438",
  "demographics-service-types": "/demographics-service-types/static-1.1672",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3204",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5787",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7358",
  "data-token-views": "/data-token-views/static-1.16423",
  "forms-utils-lib": "/forms-utils-lib/static-1.12623",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13079",
  "simple-menus-core": "/simple-menus-core/static-1.15158",
  "simple-menus-lib": "/simple-menus-lib/static-1.16675",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6849",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7536",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3528",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2593",
  "ContentEditorUI": "/ContentEditorUI/static-2.77181",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3988",
  "web-interactives-components": "/web-interactives-components/static-1.13794",
  "web-interactives-data": "/web-interactives-data/static-1.13795",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.650",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.820",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.998",
  "line-items-api": "/line-items-api/static-1.726",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3834",
  "FireAlarmUi": "/FireAlarmUi/static-1.4527",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4185",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21807",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21270",
  "data-studio-ubb": "/data-studio-ubb/static-1.2789",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27082",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57893",
  "content-management-data-lib": "/content-management-data-lib/static-1.5415",
  "copilot-plugins": "/copilot-plugins/static-1.11160",
  "cta-picker": "/cta-picker/static-1.36462",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3145",
  "editor-components": "/editor-components/static-1.13256",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8430",
  "error-messaging-js": "/error-messaging-js/static-1.5212",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85913",
  "pictos": "/pictos/static-7.184",
  "react-transition-group": "/react-transition-group/static-2.65",
  "redux-request-state": "/redux-request-state/static-1.10665",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1767",
  "smart-content-core": "/smart-content-core/static-1.42504",
  "smart-content-lib": "/smart-content-lib/static-1.43157",
  "social-composer-lib": "/social-composer-lib/static-1.59246",
  "structured-content-lib": "/structured-content-lib/static-1.25251",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53306",
  "tinymce-copilot": "/tinymce-copilot/static-1.16497",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7935",
  "automation-ui-routing": "/automation-ui-routing/static-1.21228",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5653",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42245",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3201",
  "reporting-enablement": "/reporting-enablement/static-1.23000",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21403",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2690",
  "forms-ai-lib": "/forms-ai-lib/static-1.4349",
  "codemirror-dlb": "/codemirror-dlb/static-1.58740",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6451",
  "report-customization-components": "/report-customization-components/static-1.13230",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13090",
  "html-to-image": "/html-to-image/static-1.54",
  "reporting-filters": "/reporting-filters/static-1.379",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1812"
}
};
